export default __webpack_public_path__ + "static/KFH25-003-service-card-left-bc51be18b3bc1a24351e941bb63bc09f.jpg";